import React from 'react';
import cc from 'classcat';
import { Button, NewCheckbox } from '../../Common';

export interface Topic {
    id: string;
    name: string;
    description: string;
}

interface SetCardProps {
    id: string;
    title: string;
    topics: Topic[];
    selectedTopicIds: string[];
    onChange: (topicIds: string[]) => void;
}

const SetCard: React.FC<SetCardProps> = ({ id, title, topics, selectedTopicIds, onChange }) => {
    const allSelected = topics.length > 0 && topics.every(topic => selectedTopicIds.includes(topic.id));
    const someSelected = topics.some(topic => selectedTopicIds.includes(topic.id));

    const handleSetCheckboxChange = (checked: boolean) => {
        if (checked) {
            const allTopicIds = topics.map(topic => topic.id);
            const newSelectedIds = [...new Set([...selectedTopicIds, ...allTopicIds])];
            onChange(newSelectedIds);
        } else {
            const topicIdsInSet = topics.map(topic => topic.id);
            const newSelectedIds = selectedTopicIds.filter(id => !topicIdsInSet.includes(id));
            onChange(newSelectedIds);
        }
    };

    const handleTopicCheckboxChange = (topicId: string, checked: boolean) => {
        if (checked) {
            onChange([...selectedTopicIds, topicId]);
        } else {
            onChange(selectedTopicIds.filter(id => id !== topicId));
        }
    };

    return (
        <div
            className={cc([
                'set-card',
                {
                    'set-card--checked': allSelected,
                    'set-card--partial': someSelected && !allSelected,
                },
            ])}
        >
            <div className="set-card__header">
                <h3>{title}</h3>
                <Button
                    variant="text"
                    text={allSelected ? 'Clear All' : 'Select Set'}
                    color="blue"
                    onClick={() => handleSetCheckboxChange(!allSelected)}
                ></Button>
            </div>
            {topics.length > 0 && (
                <div className="set-card__topics">
                    {topics.map(topic => (
                        <div key={topic.id} className="set-card__topic-item">
                            <NewCheckbox
                                id={`${id}-topic-${topic.id}`}
                                label={topic.name}
                                checked={selectedTopicIds.includes(topic.id)}
                                handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    e.stopPropagation();
                                    handleTopicCheckboxChange(topic.id, e.target.checked);
                                }}
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SetCard;
